import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from 'vue';
import TheDialogBase from './components/dialogs/TheDialogBase.vue';
import { useAccountStore } from './stores/account';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const accountStore = useAccountStore()
onMounted(() => {
  setTimeout(() => {
    accountStore.init()
  }, 0)
})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(accountStore).status !== 'init')
      ? (_openBlock(), _createBlock(_component_v_app, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(TheDialogBase)
  ], 64))
}
}

})